import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.layout.shellMax};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ theme }) => theme.layout.shellPadX};
  padding-right: ${({ theme }) => theme.layout.shellPadX};
`;
